import { Component, h, Prop } from '@stencil/core';
import { t } from '../../../../redux/utils';
import { BookingDetails } from '../../../../redux/types';

@Component({
  tag: 'rentware-list-articles-template',
  styleUrl: 'style.sass',
  shadow: true,
})
export class RentwareListArticlesTemplate {
  @Prop() articles;
  @Prop() tabs;
  @Prop() activeTabId: string;
  @Prop() componentLoaded: boolean;
  @Prop() stepKey: string = '';
  @Prop() bookingDetails: BookingDetails;
  @Prop() onTabClick: (number) => void;
  @Prop() onTabsLoaded: () => void;
  @Prop() onArticlesLoaded: () => void;

  render() {
    return (
      <div class="ArticlesContainer">
        <div class="ArticlesContentContainer">
          <div class="ArticlesContent">
            {(this.tabs.length > 1 && (
              <div class="TabsContainer">
                <rentware-tabs tabs={this.tabs} activeTabId={this.activeTabId} onTabClick={this.onTabClick} onTabsLoaded={this.onTabsLoaded} />
              </div>
            )) ||
              this.onTabsLoaded()}

            <rentware-spacer size="M" />

            {(this.articles?.length > 0 &&
              this.articles.map(item => {
                return <rtr-short-article key={this.stepKey + item.id} article={item} onArticlesLoaded={this.onArticlesLoaded} bookingDetails={this.bookingDetails} />;
              })) || (
              <div class="ArticleContainer">
                <rentware-spacer size="L" />

                <span class="NotFound">{t('checkout.noArticlesAvailable')}</span>
              </div>
            )}

            <rentware-spacer size="XL" />
            <rentware-spacer size="XL" />
          </div>
        </div>
      </div>
    );
  }
}
